import {RateVolumeMode, UnitSystem, WeatherColumns} from 'src/lib/api/series';

/**
 * Client-side mirror of the server's weather unit handling
 * (backend/api/common/time_series_unit_helpers.py) for the two columns the direct
 * dynamical path serves. Unit strings must match the API's exactly — chart legends,
 * tooltips, and CSV export render them verbatim.
 */

export function isVolumeMode(mode: RateVolumeMode | undefined): boolean {
  return (
    mode === 'volume' || mode === 'cumulative-volume' || mode === 'cumulative-volume-from-now'
  );
}

export function displayUnit(
  column: WeatherColumns,
  unitSystem: UnitSystem | undefined,
  rateVolumeMode: RateVolumeMode | undefined
): string {
  const us = unitSystem === UnitSystem.US;
  if (column === WeatherColumns.TEMPERATURE) {
    return us ? '°F' : '°C';
  }
  if (isVolumeMode(rateVolumeMode)) {
    return us ? 'in' : 'mm';
  }
  return us ? 'in/hr' : 'mm/hr';
}

/** Convert a value from its native unit (°C, or mm for precip depth/rate) for display. */
export function convertValue(
  value: number,
  column: WeatherColumns,
  unitSystem: UnitSystem | undefined
): number {
  if (unitSystem !== UnitSystem.US) {
    return value;
  }
  if (column === WeatherColumns.TEMPERATURE) {
    return (value * 9) / 5 + 32;
  }
  return value / 25.4;
}
